import {MenuItem} from "./common";
import {
    AppstoreOutlined,
    CameraOutlined,
    ClockCircleOutlined,
    CompressOutlined,
    ContactsOutlined,
    CreditCardOutlined,
    FileSearchOutlined, HomeOutlined,
    SearchOutlined,
    TeamOutlined,
    TransactionOutlined,
    UnorderedListOutlined,
    UserOutlined
} from "@ant-design/icons";

export const SidebarItems: MenuItem[] = [
    {
        id: 1,
        isActive: false,
        title: "پیشخوان",
        icon: <HomeOutlined/>,
        link: "/dashboard/overview"
    },
    {
        id: 4,
        isActive: false,
        title: "مدیریت کاربران",
        icon: <UserOutlined/>,
        link: "/dashboard/users",
    },

    {
        id: 7,
        isActive: false,
        title: "مشاهده سفارشات",
        icon: <ClockCircleOutlined/>,
        link: "/dashboard/orders",
    },

    {
        id: 11,
        isActive: false,
        title: "همکاران ما",
        icon: <ContactsOutlined/>,
        link: "",
        secondaryLinks: ["/dashboard/referral-infos"],
        childrens: [
            {
                id: 111,
                title: "لیست همکاران",
                link: "/dashboard/referral-infos",
            },
            {
                id: 112,
                title: "لیست درخواست برداشت های رفرال",
                link: "/dashboard/referral-withdrawals",
            },
            {
                id: 113,
                title: "لیست فعالیت همکاران",
                link: "/dashboard/referral-actions",
            },
        ],
    },
    {
        id: 12,
        isActive: false,
        title: "نقش ها",
        icon: <AppstoreOutlined/>,
        link: "/dashboard/roles",
    },
    {
        id: 13,
        isActive: false,
        title: "تصاویر مدرک کاربران",
        icon: <CameraOutlined/>,
        link: "/dashboard/media-surveys",
    },
    {
        id: 14,
        isActive: false,
        title: "مدیریت حساب های بانکی",
        icon: <CreditCardOutlined/>,
        link: "/dashboard/bank-accounts",
    },
    {
        id: 15,
        isActive: false,
        title: "تراکنش های درگاه فعال",
        icon: <TransactionOutlined/>,
        link: "/dashboard/gateway-transactions",
    },
    {
        id: 16,
        isActive: false,
        title: "جستجوی تراکنش درگاه با کد پیگیری",
        icon: <SearchOutlined/>,
        link: "/dashboard/search-gateway-transaction-by-tracking-code",
    },
    {
        id: 2,
        isActive: false,
        title: "استعلام ووچر",
        icon: <CompressOutlined/>,
        link: "/dashboard/track-voucher",
    },
    {
        id: 17,
        isActive: false,
        title: "جستجوی سفارش با کد پیگیری",
        icon: <FileSearchOutlined/>,
        link: "/dashboard/search-order-by-tracking-code",
    },
    {
        id: 18,
        isActive: false,
        title: "جستجوی کاربر با شماره موبایل",
        icon: <SearchOutlined/>,
        link: "/dashboard/get-user-by-phone-number",
    },

];

export const MobileItems: MenuItem[] = [
    {
        id: 4,
        isActive: false,
        title: "مدیریت کاربران",
        icon: <UserOutlined/>,
        link: "/dashboard/users",
    },
    {
        id: 7,
        isActive: false,
        title: "مشاهده سفارشات",
        icon: <ClockCircleOutlined/>,
        link: "/dashboard/orders",
    },
    {
        id: 111,
        title: "لیست همکاران",
        link: "/dashboard/referral-infos",
        isActive: false,
        icon: <TeamOutlined/>,
    },
    {
        id: 112,
        title: "لیست درخواست برداشت های رفرال",
        link: "/dashboard/referral-withdrawals",
        isActive: false,
        icon: <TransactionOutlined/>,
    },
    {
        id: 113,
        title: "لیست فعالیت همکاران",
        link: "/dashboard/referral-actions",
        isActive: false,
        icon: <UnorderedListOutlined/>,
    },
    {
        id: 12,
        isActive: false,
        title: "نقش ها",
        icon: <AppstoreOutlined/>,
        link: "/dashboard/roles",
    },
    {
        id: 13,
        isActive: false,
        title: "تصاویر مدرک کاربران",
        icon: <CameraOutlined/>,
        link: "/dashboard/media-surveys",
    },
    {
        id: 14,
        isActive: false,
        title: "مدیریت حساب های بانکی",
        icon: <CreditCardOutlined/>,
        link: "/dashboard/bank-accounts",
    },
    {
        id: 15,
        isActive: false,
        title: "تراکنش های درگاه فعال",
        icon: <TransactionOutlined/>,
        link: "/dashboard/gateway-transactions",
    },
    {
        id: 16,
        isActive: false,
        title: "جستجوی تراکنش درگاه با کد پیگیری",
        icon: <SearchOutlined/>,
        link: "/dashboard/search-gateway-transaction-by-tracking-code",
    },
    {
        id: 17,
        isActive: false,
        title: "جستجوی سفارش با کد پیگیری",
        icon: <FileSearchOutlined/>,
        link: "/dashboard/search-order-by-tracking-code",
    },
    {
        id: 18,
        isActive: false,
        title: "جستجوی کاربر با شماره موبایل",
        icon: <SearchOutlined/>,
        link: "/dashboard/get-user-by-phone-number",
    },

];
